import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../Store";
import { API_CENTER } from "../../../services/api/api";
import { ADD_NEW_APPLICATION } from "../applicationsSlice/applicationsSlice";
import { MatchRenderNameValueEnum } from "./types/types";

export interface LotData {
  ikz: string;
  initial_price: string;
  name_lot: string;
  offered_price: string;
  sum_avance: number;
  sum_bg: number;
  sum_bg_exetcution: number;
  sum_bg_obligation: number;
}
export interface PurchaseLotData {
  inn_customer: string;
  name_customer: string;
  lots?: LotData[];
  lot?: LotData;
}
export interface PurchaseRequestData {
  application_sum_bg: string;
  id: number;
  purchase_number: string;
  fz: string;
  subject_contract: string;
  is_closed: boolean;
  is_reprovision: boolean;
  is_sole_supplier: boolean;
  is_indisputable: boolean;
  purchase_total_at: Date;
  purchase_end_at: Date;
  purchase_lot: PurchaseLotData[];
  link: string;
}
export interface IOnfinishData {
  inn: string;
  is_tax_simple: boolean;
  fz: string;
  bg_type_id: string;
  purchase_number: string;
  is_reprovision: boolean;
  is_closed: boolean;
  is_sole_supplier: boolean;
  link: string;
  subject_contract: string;
  initial_price: string;
  total_sum: string;
  sum_avance: string;
  is_indisputable: boolean;
  purchase_total_at?: string;
  purchase_end_at?: string;
  sum_bg: string;
  number_lot: number;
  inn_customer: string;
  name_customer: string;
  organization_id: number;
  sum_bg_execution?: string;
  sum_bg_obligation?: string;
  banks?: string[];
  allBanks?: boolean;
  start_bg_at: string;
  finish_bg_at: string;
}
export interface IResponseDataCreatorRequest {
  success: boolean;
  data: {
    id: number;
    organization: {
      id: number;
      inn: string;
      ogrn: string;
      name: string;
      phone_number: string;
      email: string | null;
      snils: string | null;
    };
    purchase_lot: {
      id: number;
      ikz: string;
      initial_price: string;
      inn_customer: string;
      name_customer: string;
      name_lot: string;
      sum_bg_execution: string;
      sum_avance: string;
      sum_bg: string;
      number_lot: number;
      total_sum: string;
    };
    purchase: {
      id: number;
      purchase_number: string;
      fz: string;
      subject_contract: string;
      is_closed: boolean;
      is_reprovision: boolean;
      is_sole_supplier: boolean;
      is_indisputable: boolean;
      link: string;
      purchase_end_at: string | null;
      purchase_total_at: string;
    };
    bg_type: {
      id: number;
      name: string;
    };
    inn: string;
    total_sum: string;
    is_tax_simple: boolean;
    link: string;
    start_bg_at: string;
    finish_bg_at: string;
    types_bg: {
      id: number;
      name: string;
    }[];
  };
}
export interface IApplicationCreate {
  MATCH_STATE: {
    STAGE_CONTAINER_JSX: {
      CONTAINER_INN: "INN_GOOD" | "NOT_DATA";
      CONTAINER_PURCHASE: "PURCHASE_GOOD" | "NOT_DATA";
      CONTAINER_CONTRACTP_RICE: "CONTRACTP_RICE_GOOD" | "NOT_DATA";
    };
    // поиск по инн  <\/>
    STAGE_INN: "INN_GOOD" | "INN_BAD" | "BAD_REQUEST" | "NOT_DATA" | "NOT_DATA";
    // выбор закупки Закон или Комерчиская <\/>
    STAGE_TYPE_PURCHASE_FZ: "223" | "44" | "185" | "COMERCIAL" | "NOT_DATA";
    // ИКЗ <\/>
    STAGE_IKZ: "IKZ" | "NOT_DATA" | "IKZ_REQUIRED";
    // ТИП ЗАкупки <\/>
    TYPE_PURCHASE_OPTIONS:
      | "PERFORMANCE_OF_CONTRACT"
      | "GUARANTEE_PROMISE"
      | "PARTICIPATION"
      | "REFUND_OF_ADVANCE"
      | "PAYMENT_GUARANTEE"
      | "NOT_DATA";
    // Поиск Закупки
    STAGE_SEARCH_BG: "STAGE_SEARCH_1" | "NOT_DATA";
    // чекбоксы  (Переобеспечение) (Закрытый аукцион) (Единственный поставщик) <\/>
    STAGE_CHECK_BOX_RE_PROVISION:
      | "PROVISION_STAGE_ALL"
      | "PROVISION_STAGE_PROVISION"
      | "NOT_DATA";
    // группа инпутов Заказчик <\/>
    STATE_CUSTOMER: "CUSTOMER_STAGE_ALL" | "NOT_DATA";
    // группа Цена контракта <\/>
    STAGE_CONTRACT:
      | "CONTRACT_STAGE_1"
      | "CONTRACT_STAGE_2"
      | "CONTRACT_STAGE_3"
      | "CONTRACT_STAGE_4"
      | "NOT_DATA";
    // группа аукцион <\/>
    STAGE_AUCTION:
      | "AUCTION_STAGE_1"
      | "AUCTION_STAGE_2"
      | "AUCTION_STAGE_3"
      | "AUCTION_STAGE_4"
      | "NOT_DATA";
    // группа Начало и окончание БГ <\/>
    STAGE_START_BG:
      | "START_BG_STAGE_1"
      | "START_BG_STAGE_2"
      | "START_BG_STAGE_3"
      | "NOT_DATA";
  };
  STAGE_INN_REQUEST: {
    success: boolean;
    data?: {
      created_at: string;
      email: string;
      id: number;
      inn: string;
      name: string;
      ogrn: string;
      phone_number: string;
      snils: string | null;
      updated_at: string;
      status_company: string;
    };
    message: string;
  };
  PURCHASE_REQUEST: {
    success: boolean;
    data?: PurchaseRequestData;
  };
  SWAP_PAGE_REQUEST_CREATE: boolean;
  SWAP_PAGE_REQUEST_CREATE_DATA: IResponseDataCreatorRequest | null;
}
const API = new API_CENTER();
export const API_STAGE_INN_REQUEST = createAsyncThunk<
  IApplicationCreate["STAGE_INN_REQUEST"],
  string,
  {
    rejectValue: IApplicationCreate["STAGE_INN_REQUEST"]; // указывает, что функция должна возвращать
  }
>("profileSlice/API_STAGE_INN_REQUEST", async (value, { rejectWithValue }) => {
  const response = await API.GET_API(`organizations?inn=${value}`, "GET");
  if (response.success) {
    return response;
  } else {
    return rejectWithValue(response); // выбросить ошибку с сообщением
  }
});
export const API_STAGE_SAVED_APPLICATION = createAsyncThunk<
  IResponseDataCreatorRequest,
  IOnfinishData,
  {
    rejectValue: string;
    state: { applicationCreateSlice: IApplicationCreate }; // !!!!! Обращение к общему стору всего редакса !!!!!
  }
>(
  "profileSlice/API_STAGE_SAVED_APPLICATION",
  async (value, { rejectWithValue, getState, dispatch }) => {
    const organization_id =
      getState().applicationCreateSlice.STAGE_INN_REQUEST.data?.id;
    const pushToServerObj = { ...value, organization_id };
    const response = await API.GET_API(`applications`, "POST", pushToServerObj);
    if (response.success) {
      dispatch(
        ADD_NEW_APPLICATION({
          ...response.data,
          status: {
            id: 6,
            title: "Черновик",
            color: "default",
            info: "Черновик",
            info_color: "info",
          },
        })
      );
      return response;
    } else {
      return rejectWithValue(response); // выбросить ошибку с сообщением
    }
  }
);
//purchases?purchase_number=0820500000823005164
export const API_STAGE_PURCHASE_SEARCH_REQUEST = createAsyncThunk<
  IApplicationCreate["PURCHASE_REQUEST"],
  string,
  {
    rejectValue: IApplicationCreate["STAGE_INN_REQUEST"]; // указывает, что функция должна возвращать
  }
>(
  "applicationCreateSlice/API_STAGE_PURCHASE_SEARCH_REQUEST",
  async (value, { rejectWithValue }) => {
    if (value.length === 11 || value.length === 18 || value.length === 19) {
      const response = await API.GET_API(`purchases/${value}/service`, "GET");
      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response); // выбросить ошибку с сообщением
      }
    }
  }
);
const initialState: IApplicationCreate = {
  MATCH_STATE: {
    STAGE_INN: "NOT_DATA",
    STAGE_CONTAINER_JSX: {
      CONTAINER_INN: "NOT_DATA",
      CONTAINER_PURCHASE: "NOT_DATA",
      CONTAINER_CONTRACTP_RICE: "NOT_DATA",
    },
    TYPE_PURCHASE_OPTIONS: "NOT_DATA",
    STAGE_TYPE_PURCHASE_FZ: "NOT_DATA",
    STAGE_SEARCH_BG: "NOT_DATA",
    STAGE_CHECK_BOX_RE_PROVISION: "NOT_DATA",
    STAGE_IKZ: "NOT_DATA",
    STATE_CUSTOMER: "NOT_DATA",
    STAGE_CONTRACT: "NOT_DATA",
    STAGE_AUCTION: "NOT_DATA",
    STAGE_START_BG: "NOT_DATA",
  },
  STAGE_INN_REQUEST: {
    success: false,
    message: "",
  },
  PURCHASE_REQUEST: {
    success: false,
  },
  SWAP_PAGE_REQUEST_CREATE: false,
  SWAP_PAGE_REQUEST_CREATE_DATA: null,
};

// создание заявки
const applicationCreateSlice = createSlice({
  name: "APPLICATION_CREATE_SLICE",
  initialState,
  reducers: {
    // рендер нужных полей
    MATCH_OFF_RENDERINGS: (state, action) => {
      const keyName = Object.keys(
        action.payload
      )[0] as keyof typeof state.MATCH_STATE.STAGE_CONTAINER_JSX;
      const value = action.payload;
      if (state.MATCH_STATE.STAGE_CONTAINER_JSX[keyName]) {
        state.MATCH_STATE.STAGE_CONTAINER_JSX[keyName] = value[keyName];
      }
    },
    // значения которые надо рендерить в создании заявки
    MATCH_VALUE_RENDERS: (
      state,
      action: {
        payload: {
          value: unknown;
          nameValue: MatchRenderNameValueEnum;
        };
      }
    ) => {
      const { value, nameValue } = action.payload;
      if (nameValue === MatchRenderNameValueEnum.isTaxSimple) {
        state.MATCH_STATE.STAGE_CONTAINER_JSX.CONTAINER_PURCHASE =
          "PURCHASE_GOOD";
      }
      if (nameValue === MatchRenderNameValueEnum.fz) {
        if (value === "223" || value === "44") {
          state.MATCH_STATE.STAGE_SEARCH_BG = "STAGE_SEARCH_1";
          state.MATCH_STATE.STAGE_CHECK_BOX_RE_PROVISION =
            "PROVISION_STAGE_ALL";
        } else if (value === "commerce") {
          state.MATCH_STATE.STAGE_SEARCH_BG = "NOT_DATA";
          state.MATCH_STATE.STAGE_CHECK_BOX_RE_PROVISION =
            "PROVISION_STAGE_PROVISION";
        } else {
          state.MATCH_STATE.STAGE_SEARCH_BG = "STAGE_SEARCH_1";
          state.MATCH_STATE.STAGE_CHECK_BOX_RE_PROVISION =
            "PROVISION_STAGE_PROVISION";
        }
      }

      if (nameValue === MatchRenderNameValueEnum.bgTypeId) {
        if (value == 2) {
          // Исполнение контракта
          state.MATCH_STATE.STAGE_AUCTION = "AUCTION_STAGE_1";
          state.MATCH_STATE.STAGE_CONTRACT = "CONTRACT_STAGE_1";
        } else if (value == 4) {
          // Гарантийные обязательства
          state.MATCH_STATE.STAGE_AUCTION = "AUCTION_STAGE_2";
          state.MATCH_STATE.STAGE_CONTRACT = "CONTRACT_STAGE_1";
        } else if (value == 1) {
          // Участие
          state.MATCH_STATE.STAGE_AUCTION = "AUCTION_STAGE_3";
          state.MATCH_STATE.STAGE_CONTRACT = "CONTRACT_STAGE_3";
        } else if (value == 3) {
          // Возврат аванса
          state.MATCH_STATE.STAGE_AUCTION = "AUCTION_STAGE_1";
          state.MATCH_STATE.STAGE_CONTRACT = "CONTRACT_STAGE_4";
        } else {
          state.MATCH_STATE.STAGE_AUCTION = "AUCTION_STAGE_1";
          state.MATCH_STATE.STAGE_CONTRACT = "CONTRACT_STAGE_1";
        }
        // state.MATCH_STATE.STAGE_SEARCH_BG = "STAGE_SEARCH_1";
        // state.MATCH_STATE.STAGE_CHECK_BOX_RE_PROVISION = "PROVISION_STAGE_ALL";
        state.MATCH_STATE.TYPE_PURCHASE_OPTIONS = "PERFORMANCE_OF_CONTRACT";
        state.MATCH_STATE.STAGE_START_BG = "START_BG_STAGE_1";
        state.MATCH_STATE.STATE_CUSTOMER = "CUSTOMER_STAGE_ALL";
      }
    },
    // отображение коммерческой и не коммерческой бг
    PORTIAL_DISPLAY_STAGE_PURCHASE: (state, action) => {
      const keyName = Object.keys(
        action.payload
      )[0] as keyof typeof state.MATCH_STATE;
      const value = action.payload;
      state.MATCH_STATE[keyName] = value[keyName];
    },
    // очистка создания заявки
    CLEAR_CREATE_APLICATION: (state, action: { payload: "clear" }) => {
      if (action.payload === "clear") {
        return initialState;
      }
    },
    ADD_STAGE_IN_REQUEST_CLIENT: (state, action) => {
      if (action.payload) {
        state.STAGE_INN_REQUEST = action.payload;
        state.MATCH_STATE.STAGE_CONTAINER_JSX.CONTAINER_INN = "INN_GOOD";
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(API_STAGE_INN_REQUEST.fulfilled, (state, action) => {
      if (action.payload) {
        state.STAGE_INN_REQUEST = action.payload;
        state.MATCH_STATE.STAGE_CONTAINER_JSX.CONTAINER_INN = "INN_GOOD";
      }
    });
    builder.addCase(
      API_STAGE_PURCHASE_SEARCH_REQUEST.fulfilled,
      (state, action) => {
        if (action.payload) {
          state.PURCHASE_REQUEST = action.payload;
          state.MATCH_STATE.STATE_CUSTOMER = "CUSTOMER_STAGE_ALL";
        } /*  */
      }
    );
    builder.addCase(API_STAGE_PURCHASE_SEARCH_REQUEST.rejected, (state) => {
      state.PURCHASE_REQUEST = { success: false };
    });
    builder.addCase(API_STAGE_SAVED_APPLICATION.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.SWAP_PAGE_REQUEST_CREATE = action.payload.success;
        state.SWAP_PAGE_REQUEST_CREATE_DATA = action.payload;
      }
    });
  },
});

export const selectApplicationCreateSlice = (state: RootState) =>
  state.applicationCreateSlice;
export const {
  MATCH_OFF_RENDERINGS,
  PORTIAL_DISPLAY_STAGE_PURCHASE,
  MATCH_VALUE_RENDERS,
  CLEAR_CREATE_APLICATION,
  ADD_STAGE_IN_REQUEST_CLIENT,
} = applicationCreateSlice.actions;
export default applicationCreateSlice.reducer;
